<!-- Header -->
<app-cabecalho></app-cabecalho>

<!-- Hero Section -->
<section class="hero" id="home">
  <div class="hero-content">
    <div class="hero-text">
      <div class="hero-badge">
        <i class="fas fa-rocket"></i>
        Startup em crescimento - 4 pessoas apaixonadas por tecnologia
      </div>
      <h1 class="hero-title">
        {{ "PAGINA_INICIAL.BANNER_PRINCIPAL.TITULO" | translate }}
      </h1>
      <p class="hero-subtitle">
        Desenvolvemos soluções inteligentes que conectam pessoas e otimizam
        processos. Nossa missão é tornar a tecnologia acessível e poderosa para
        todos os tipos de negócio.
      </p>
      <div class="hero-buttons">
        <button class="btn-primary" (click)="scrollToSection('products')">
          Conheça o Bardo <i class="fas fa-arrow-right"></i>
        </button>
        <button class="btn-secondary" (click)="navigateToTrial()">
          <i class="fas fa-play"></i> Trial 1 Mês Grátis
        </button>
      </div>
    </div>
    <div class="hero-visual">
      <div class="floating-dashboard">
        <div class="dashboard-main">
          <div class="dashboard-header">
            <div class="dashboard-avatar">
              <i class="fas fa-calendar-plus"></i>
            </div>
            <div class="dashboard-info">
              <h4>Bardo Dashboard</h4>
              <p>Gestão inteligente de agendamentos</p>
            </div>
          </div>
          <div class="dashboard-stats">
            <div class="stat-card">
              <div class="stat-number">247</div>
              <div class="stat-label">Agendamentos</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">15</div>
              <div class="stat-label">Profissionais</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">98%</div>
              <div class="stat-label">Satisfação</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">+35%</div>
              <div class="stat-label">Crescimento</div>
            </div>
          </div>
        </div>
        <div class="floating-elements">
          <div class="floating-card floating-card-1">
            <i
              class="fas fa-mobile"
              style="color: #3b82f6; font-size: 1.2rem"
            ></i>
          </div>
          <div class="floating-card floating-card-2">
            <i
              class="fas fa-chart-line"
              style="color: #3b82f6; font-size: 1.2rem"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- About Section -->
<section class="about" id="about">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Quem Somos</span>
      <h2 class="section-title">
        Uma Startup que Acredita na Tecnologia como Transformação
      </h2>
      <p class="section-subtitle">
        Somos uma equipe jovem e inovadora, focada em criar soluções que
        realmente fazem a diferença na vida das pessoas e no crescimento dos
        negócios.
      </p>
    </div>
    <div class="about-content">
      <div class="about-text">
        <p>{{ "PAGINA_INICIAL.SECAO_SOBRE.P1" | translate }}</p>
        <br />
        <p>{{ "PAGINA_INICIAL.SECAO_SOBRE.P2" | translate }}</p>
        <br />
        <p>{{ "PAGINA_INICIAL.SECAO_SOBRE.P3" | translate }}</p>
        <p>{{ "PAGINA_INICIAL.SECAO_SOBRE.P4" | translate }}</p>
      </div>
      <div class="about-features">
        <div class="feature-item fade-in">
          <div class="feature-icon">
            <i class="fas fa-lightbulb"></i>
          </div>
          <div class="feature-text">
            <h4>Inovação Constante</h4>
            <p>Sempre buscando as melhores tecnologias e práticas de mercado</p>
          </div>
        </div>
        <div class="feature-item fade-in">
          <div class="feature-icon">
            <i class="fas fa-shield"></i>
          </div>
          <div class="feature-text">
            <h4>Confiabilidade</h4>
            <p>Sistemas robustos e seguros que você pode confiar</p>
          </div>
        </div>
        <div class="feature-item fade-in">
          <div class="feature-icon">
            <i class="fas fa-heart"></i>
          </div>
          <div class="feature-text">
            <h4>Simplicidade</h4>
            <p>Tecnologia complexa por trás, experiência simples na frente</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Products Section -->
<section class="products" id="products">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Nossos Produtos</span>
      <h2 class="section-title">
        {{ "PAGINA_INICIAL.SECAO_SOLUCOES.TITULO" | translate }}
      </h2>
      <p class="section-subtitle">
        Desenvolvemos produtos que atendem diferentes necessidades, sempre com
        foco na qualidade e inovação.
      </p>
    </div>
    <div class="products-grid">
      <div class="product-card fade-in">
        <div class="product-header">
          <div class="product-icon">
            <i class="fas fa-calendar"></i>
          </div>
          <div>
            <h3 class="product-title">
              {{
                "PAGINA_INICIAL.SECAO_SOLUCOES.SISTEMA_BARDO.BARDO" | translate
              }}
            </h3>
            <p class="product-subtitle">Plataforma Universal de Agendamento</p>
          </div>
        </div>
        <p class="product-description">
          {{
            "PAGINA_INICIAL.SECAO_SOLUCOES.SISTEMA_BARDO.DESCRICAO" | translate
          }}
        </p>
        <ul class="product-features">
          <li>Agenda inteligente com múltiplas visualizações</li>
          <li>Integração nativa com WhatsApp Business</li>
          <li>Gestão completa de profissionais e serviços</li>
          <li>Notificações automáticas e lembretes</li>
          <li>Dashboard com métricas e relatórios</li>
          <li>Interface responsiva para todos os dispositivos</li>
        </ul>
        <button class="product-cta" (click)="navigateToTrial()">
          {{ "PAGINA_INICIAL.SECAO_SOLUCOES.SISTEMA_BARDO.BOTAO" | translate }}
          <i class="fas fa-arrow-right"></i>
        </button>
      </div>

      <div class="product-card fade-in">
        <div class="product-header">
          <div class="product-icon">
            <i class="fas fa-shop"></i>
          </div>
          <div>
            <h3 class="product-title">Integrator</h3>
            <p class="product-subtitle">Gestão de Marketplaces</p>
          </div>
        </div>
        <p class="product-description">
          Sistema integrado para gerenciar múltiplos marketplaces em um só
          lugar. Conecte Mercado Livre, Shopee, Amazon e muito mais com
          facilidade total.
        </p>
        <ul class="product-features">
          <li>Integração com principais marketplaces</li>
          <li>Gestão centralizada de produtos</li>
          <li>Controle de estoque unificado</li>
          <li>Relatórios de vendas consolidados</li>
          <li>Automação de processos</li>
          <li>Painel único para múltiplas plataformas</li>
        </ul>
        <button class="product-cta" (click)="navigateTo()">
          Em Desenvolvimento <i class="fas fa-clock"></i>
        </button>
      </div>

      <div class="product-card fade-in">
        <div class="product-header">
          <div class="product-icon">
            <i class="fas fa-code"></i>
          </div>
          <div>
            <h3 class="product-title">Sites Sob Medida</h3>
            <p class="product-subtitle">Desenvolvimento Personalizado</p>
          </div>
        </div>
        <p class="product-description">
          Criamos sites corporativos e pessoais totalmente personalizados, desde
          landing pages até sistemas complexos, sempre alinhados com sua marca e
          objetivos.
        </p>
        <ul class="product-features">
          <li>Design responsivo e moderno</li>
          <li>Desenvolvimento personalizado</li>
          <li>Otimização para SEO</li>
          <li>Integração com sistemas existentes</li>
          <li>Suporte técnico especializado</li>
          <li>Hospedagem e manutenção</li>
        </ul>
        <button class="product-cta" (click)="navigateTo()">
          Solicitar Orçamento <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Team Section -->
<section class="team" id="team">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Nosso Time</span>
      <h2 class="section-title">Pessoas Apaixonadas por Tecnologia</h2>
      <p class="section-subtitle">
        Conheça a equipe que torna tudo isso possível. Cada um com sua
        expertise, unidos pela paixão em criar soluções incríveis.
      </p>
    </div>
    <div class="team-grid">
      @for (member of teamMembers(); track member.name) {
      <div class="team-card fade-in">
        <div class="team-avatar">{{ member.initials }}</div>
        <h3 class="team-name">{{ member.name }}</h3>
        <p class="team-role">{{ member.role }}</p>
        <p class="team-description">{{ member.description }}</p>
      </div>
      }
    </div>
  </div>
</section>

<!-- Stats Section -->
<section class="stats">
  <div class="container">
    <div class="stats-grid">
      @for (stat of stats(); track stat.label) {
      <div class="stat-item">
        <div
          class="stat-number counter"
          [attr.data-count]="stat.number"
          [attr.data-suffix]="stat.suffix"
        >
          0
        </div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
      }
    </div>
  </div>
</section>

<!-- Cases Section -->
<section class="cases" id="cases">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Cases de Sucesso</span>
      <h2 class="section-title">Transformando Negócios Reais</h2>
      <p class="section-subtitle">
        Veja como nossas soluções estão impactando positivamente diferentes
        tipos de negócios e profissionais.
      </p>
    </div>
    <div class="products-grid">
      <div class="product-card fade-in">
        <div class="product-header">
          <div class="product-icon">
            <i class="fas fa-user-plus"></i>
          </div>
          <div>
            <h3 class="product-title">Dra . Gabriela Alves</h3>
            <p class="product-subtitle">Consultório Odontológico</p>
          </div>
        </div>
        <p class="product-description">
          "Com o Bardo, reduzi em 70% os cancelamentos de última hora e aumentei
          a satisfação dos pacientes com lembretes automáticos por WhatsApp."
        </p>
        <ul class="product-features">
          <li>70% menos no-shows</li>
          <li>Aumento de 45% na produtividade</li>
          <li>Pacientes mais satisfeitos</li>
          <li>Processo mais organizado</li>
        </ul>
      </div>

      <div class="product-card fade-in">
        <div class="product-header">
          <div class="product-icon">
            <i class="fas fa-palette"></i>
          </div>
          <div>
            <h3 class="product-title">Gráfica Impressa</h3>
            <p class="product-subtitle">Gráfica Digital</p>
          </div>
        </div>
        <p class="product-description">
          "Nossos clientes adoram a facilidade para agendar serviços. Aumentamos
          60% nossa receita desde que começamos a usar o Bardo!"
        </p>
        <ul class="product-features">
          <li>60% aumento na receita</li>
          <li>Cliente final mais satisfeito</li>
          <li>Gestão simplificada da equipe</li>
          <li>Maior controle financeiro</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Trial Section -->
<section class="trial" id="trial">
  <div class="container">
    <div class="trial-content">
      <div class="trial-text">
        <h2 class="trial-title">
          {{ "PAGINA_INICIAL.BANNER_TESTE.TITULO" | translate }}
        </h2>
        <p class="trial-subtitle">
          {{ "PAGINA_INICIAL.BANNER_TESTE.DESCRICAO" | translate }}
        </p>
        <!-- <p class="trial-note">
          Sem cartão de crédito • Sem compromisso • Suporte incluso
        </p> -->
      </div>
      <div class="trial-actions">
        <div class="trial-buttons">
          <button class="btn-primary trial-btn" (click)="navigateToTrial()">
            {{ "PAGINA_INICIAL.BANNER_TESTE.BOTAO" | translate }}
            <i class="pi pi-arrow-right"></i>
          </button>
          <button class="btn-secondary" (click)="navigateToLogin()">
            <i class="pi pi-sign-in"></i> Entrar/Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<app-rodape></app-rodape>
